import React from 'react';
import { FunctionDefinition, FunctionPortDefinition } from '@glueapp/graph-types';

interface FunctionPortEditingContextType {
    functionDefinition?: FunctionDefinition;
    updateFunctionInputs?: (inputPorts: FunctionPortDefinition[]) => void;
    updateFunctionOutputs?: (outputPorts: FunctionPortDefinition[]) => void;
}

export const FunctionPortEditingContext = React.createContext<FunctionPortEditingContextType>({});

interface FunctionPortEditingContextProviderProps {
    functionDefinition?: FunctionDefinition;
    updateFunctionInputs?: (inputPorts: FunctionPortDefinition[]) => void;
    updateFunctionOutputs?: (outputPorts: FunctionPortDefinition[]) => void;
    children: React.ReactNode;
}

export const FunctionPortEditingContextProvider: React.FC<FunctionPortEditingContextProviderProps> = ({
    functionDefinition,
    updateFunctionInputs,
    updateFunctionOutputs,
    children,
}) => {
    return (
        <FunctionPortEditingContext.Provider
            value={{
                functionDefinition,
                updateFunctionInputs,
                updateFunctionOutputs,
            }}
        >
            {children}
        </FunctionPortEditingContext.Provider>
    );
};
